import { Col, Row } from "antd";
import React from "react";
// import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { USER_INFO } from "../../common/constant";
import { selectProfile } from "../../redux/reducers/slice/profile";
import Avatar from "../avatar";
import ProfileChangePassword from "../profileChangePassword";
import ProfileInformation from "../profileInformation";
import "./style.scss";

const ProfileInformationDetail = (props: any) => {
  let userInfo = JSON.parse(`${localStorage.getItem(USER_INFO)}`);
  const profile = useSelector(selectProfile);
  // const { t } = useTranslation();

  React.useEffect(() => {
    if (!profile.loading && profile.isUpdatted) {
      userInfo = JSON.parse(`${localStorage.getItem(USER_INFO)}`);
    }
  }, [profile.isUpdatted]);

  const getGender = () => {
    if (userInfo.gender === 1) return "Mr.";
    if (userInfo.gender === 2) return "Ms.";

    return "Hi,";
  };
  return (
    <Row justify="center" align="middle" className="kd-profile-container">
      <Col span={24}>
        <Row justify="center" align="middle">
          <span className="main-title kd-profile-title">MY PROFILE</span>
          {/* <span className="main-content kd-profile-go-back">
            Quay lại trang thông tin
          </span> */}
        </Row>
        {/* <Row justify="start" align="middle">
          
        </Row> */}
        <Row justify="center" align="middle">
          <Col className="kd-profile-content-wrapper">
            <Row>
              <Avatar />
              <Col className="kd-profile-detail-name-wrap">
                <div>
                  <span className="sub-title">
                    {getGender()} {userInfo.full_name.split(" ")[0]}
                  </span>
                </div>
                <div>
                  <span className="sub-title">
                    Phone: {userInfo.phone_number}
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <ProfileInformation />
            </Row>
            <Row>
              <ProfileChangePassword />
            </Row>
            {/* <ProfileInformation />
            <ProfileChangePassword /> */}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ProfileInformationDetail;
